<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item"
    :class="{
      active: isActive,
      disabled: item.disabled,
      hidden: item.hidden,
    }"
  >
    <b-link
      v-bind="linkProps"
      class="d-flex align-items-center"
      @click="linkProps.modal ? modal(linkProps.modal) : null"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl';
import { BLink, BBadge } from 'bootstrap-vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import useVerticalNavMenuLink from './useVerticalNavMenuLink';
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink';
import useJwt from '@/auth/jwt/useJwt';
export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
    };
  },
  methods: {
    modal(e) {
      switch (e) {
        case `importarNovosCadastrosEvent`:
          this.importarNovosCadastros();
          break;
        case `importarAgendamentosEvent`:
          this.importarAgendamentos();
          break;
      }
    },
    async importarAgendamentos() {
      this.$swal({
        title: 'Atenção!',
        text: 'Deseja realmente baixar dados de agendamento?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim!',
        cancelButtonText: 'Não!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.$swal({
            title: 'Atenção!',
            text: 'Realizando operação, aguarde...',
            showCancelButton: false,
            showConfirmButton: false,
          });

          try {
            await useJwt.get(
              `importacao/agendamentosInterno/${this.userData?.institutoSelecionado}`
            );

            this.$swal({
              title: 'Atenção!',
              text: 'Agendamentos importados com sucesso!',
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            });
          } catch (error) {
            this.$swal({
              title: 'Atenção!',
              text: 'Ops... algo de errado aconteceu, tente novamente!',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            });
          }
        }
      });
    },
    async importarNovosCadastros() {
      this.$swal({
        title: 'Atenção!',
        text: 'Deseja realmente baixar novos cadastros para o sistema?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim!',
        cancelButtonText: 'Não!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.$swal({
            title: 'Atenção!',
            text: 'Realizando operação, aguarde...',
            showCancelButton: false,
            showConfirmButton: false,
          });

          try {
            await useJwt.get(
              `importacao/novosCadastrosInterno/${this.userData?.institutoSelecionado}`
            );

            this.$swal({
              title: 'Atenção!',
              text: 'Novos cadastros importadas com sucesso!',
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            });
          } catch (error) {
            this.$swal({
              title: 'Atenção!',
              text: 'Ops... algo de errado aconteceu, tente novamente!',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            });
          }
        }
      });
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(
      props.item
    );
    const { t } = useI18nUtils();
    const { canViewVerticalNavMenuLink } = useAclUtils();

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    };
  },
};
</script>
